import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function RefundPolicy() {
  const navigate = useNavigate();
  const { id } = useParams();
  function handleTransactionId() {
    navigate(id === undefined ? '/refund' : `/refund/${id}`);
    window.scrollTo(0, 0);
  }

  return (
    <div className='p-4 w-full h-full flex flex-col justify-start items-center text-white mt-6 content-t'>
      <h1 className='text-center font-anton font-[20px]'>
        This Policy is a legally binding document between you (“Visitor”/
        “User”) and Pukka Entertainment Private Limited & its platform Cricket8
        (“Company”, “Platform”, “we”, “us”, and “our”).
      </h1>
      <div className='w-full'>
        <h1 className='text-center font-anton font-[20px] mt-5'>
          ABOUT CRICKET8
        </h1>
        <p className='text-[16px] font-[400] text-gray-300 mb-1'>
          Cricket8 is a community built by cricket fans, for cricket fans. With
          a growing base of 800,000 passionate cricket enthusiasts, we are more
          than just a sports platform. Our mission is to bring fans closer to
          the game they love through high-quality gaming, real-time engagement,
          and interactive experiences.
        </p>
      </div>
      <div className='w-full'>
        <h1 className='text-center font-anton font-[20px] mt-1'>
          OUR PRODUCTS
        </h1>
        <p className='text-[16px] text-start font-[400] mb-1'>
          Cricket8 offers a premium, real-time experience for cricket lovers,
          including:
        </p>
        <ul className='text-[16px] text-start font-[400] text-gray-300'>
          <li>
            Live Gaming: Ball by ball, over by over, and match by match,
            covering every market.
          </li>
          <li>
            Live Sports Data: Instant updates, scores, and in-depth statistics.
          </li>
          <li>
            Live Streaming Commentary: Bringing the action to life, ball by
            ball.
          </li>
          <li>
            Exclusive Videos & Podcasts: Expert insights, match analysis, and
            behind-the-scenes content.
          </li>
        </ul>
        <h1 className='text-center font-anton font-[20px] mt-1'>
          PLAY. COMPETE. WIN (BRAGGING RIGHTS).
        </h1>
        <p className='text-[16px] text-start font-[400] text-gray-300 mb-1'>
          Our games capture the thrill of predicting outcomes without the risk
          of real money gambling:
        </p>
        <ul>
          <li>
            No Gambling, Just Fun: Compete, strategize, and challenge your
            friends without wagering real money.
          </li>
          <li>
            Virtual Coins, Real Excitement: Players can buy rubies, convert them
            into virtual coins, and climb leaderboards for ultimate bragging
            rights.
          </li>
        </ul>
      </div>
      <div className='w-full text-start'>
        <h1 className='text-center font-anton font-[20px] mt-5'>
          CANCELLATION AND REFUND POLICY FOR Cricket8.com
        </h1>
        <p className='text-center font-anton font-[20px] mt-5'>
          1. PAYMENT AND BILLING
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          1.1 PAYMENT OVERVIEW
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Our platform offers services that can be purchased using Razorpay. By
          completing a payment, you confirm that you are authorized to use the
          selected payment method and that all payment details provided are
          accurate.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          1.2 TRANSACTION PROCESSING
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Payments made through Razorpay are processed in accordance with their
          terms of service. Please refer to these terms for more details about
          the transaction process and any associated requirements.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          1.2 TRANSACTION PROCESSING
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Payments made through Razorpay are processed in accordance with their
          terms of service. Please refer to these terms for more details about
          the transaction process and any associated requirements.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>1.3 PRICING</p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          All prices displayed on our platform are inclusive of applicable taxes
          unless stated otherwise. Prices are subject to change at any time
          without prior notice.
        </p>
        <p className='text-center font-anton font-[20px] mt-5'>2. REFUNDS</p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          2.1 ELIGIBILITY FOR REFUNDS
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Refund requests must comply with this policy and Razorpay’s refund
          policies. Refunds will only be issued to the original payment method
          used at the time of purchase. Refunds for ruby pack purchases only
          apply to packs that have not yet been spent in full or in part (spent
          on play coins). We cannot offer part refunds for unspent rubies. No
          cash refunds will be issued under any circumstances, as our platform
          does not involve monetary or tangible rewards.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          2.2 HOW TO REQUEST A REFUND
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          To request a refund, please send us the following information via our
          customer contact form:
        </p>
        <ul>
          <li>Order ID</li>
          <li>Payment reference number (Razorpay Transaction ID)</li>
          <li>Reason for refund</li>
          <li>Supporting documents (if applicable)</li>
          <li>
            Our team will review your request and respond within 3–5 business
            days.
          </li>
        </ul>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          2.3 REFUND TIMELINES
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          All prices displayed on our platform are inclusive of applicable taxes
          unless stated otherwise. Prices are subject to change at any time
          without prior notice.
        </p>
      </div>
      <div className='w-full'>
        <p className='text-[16px] text-gray-300 mt-1'>
          If your refund is approved, Razorpay will initiate the refund to the
          original payment method. Refunds are usually credited within 5–10
          business days, depending on your bank or card issuer. You will be
          notified via Razorpay when the refund is processed.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          2.4 NON-REFUNDABLE ITEMS
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Refunds will not be issued for the following:
        </p>
        <ul>
          <li>
            Digital goods or services that have been accessed, used, or
            downloaded.
          </li>
          <li>
            Items marked as "final sale" or otherwise non-refundable at the time
            of purchase.
          </li>
          <li>Reason for refund</li>
          <li>
            Issues caused by user error or misuse of the product or service.
          </li>
          <li>
            Virtual coins (converted from rubies) that have been used in any
            capacity within our games.
          </li>
        </ul>

        <h1 className='text-center font-anton font-[20px] mt-5'>
          3. NO GAMBLING, NO MONETARY REWARDS
        </h1>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          3.1 NATURE OF OUR GAMES
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          All games on Cricket8 are casual/social in nature and do not involve
          any form of gambling or betting, as defined under Indian law. Our
          games are skill-based, designed to provide an engaging and competitive
          experience.
          <span className='font-bold'>
            {' '}
            Games are intended purely for entertainment and do not offer any
            cash prizes, monetary rewards, or tangible items as incentives.
          </span>
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          3.2 VIRTUAL CURRENCY POLICY
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          Virtual coins obtained through the purchase of rubies are purely for
          in-game use and cannot be redeemed for cash, monetary rewards, or
          tangible goods. These virtual coins are non-transferable,
          non-redeemable, and cannot be exchanged for any form of real-world
          value. They can only be used within the Cricket8 platform for in-game
          activities such as accessing premium features, unlocking additional
          content, or enhancing gameplay.
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          3.3 NO CASH OR MONETARY REWARDS
        </p>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          No cash prizes or rewards of monetary or tangible value are provided
          to players, regardless of game outcomes or performance. Players earn
          only virtual coins, which have no cash value and cannot be withdrawn
          or converted into real money.
        </p>
      </div>
      <div className='w-full'>
        <h1 className='text-center font-anton font-[20px] mt-5'>
          4. UNAUTHORIZED TRANSACTIONS
        </h1>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          If you believe a transaction was unauthorized, immediately report it
          to Razorpay via their customer support team. We will work with
          Razorpay to resolve the issue.
        </p>
      </div>
      <div className='w-full'>
        <h1 className='text-center font-anton font-[20px] mt-5'>
          5. CHANGES TO THIS POLICY
        </h1>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          We may update this Refund Policy from time to time. Updates will be
          posted on our website, and significant changes will be communicated to
          you via email or other means. Continued use of our website after
          updates constitutes acceptance of the revised policy.
        </p>
      </div>
      <div className='w-full'>
        <h1 className='text-center font-anton font-[20px] mt-5'>
          6. CONTACT INFORMATION
        </h1>
        <p className='text-[16px] font-[400] text-gray-300 mt-1'>
          If you have any questions, concerns, or refund requests, please
          contact us through our customer{' '}
          <Link className='underline font-bold' to='/contact'>
            support form
          </Link>
        </p>
      </div>
    </div>
  );
}
